<template>
  <div>
    <input
      :type="type ? type : false"
      class="form-input"
      :class="{ 'form-input-error': error }"
      :placeholder="placeholder ? placeholder : false"
      @input="handleInput"
      @blur="handleBlur"
      v-model="content"
    />
    <form-field-error :error="error" :message="errorMessage"></form-field-error>
  </div>
</template>

<script>
import FormFieldError from './FormFieldError.vue'

export default {
  components: { FormFieldError },
  props: {
    type: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    error: {
      default: false,
    },
    errorMessage: {
      type: String,
      default: 'Invalid Field',
    },
  },
  data() {
    return {
      content: this.value,
    }
  },
  methods: {
    handleInput() {
      if (this.type === 'tel') {
        var x = this.content.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
        this.content = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')

        return this.$emit('input', this.content.replace(/\D/g, ''))
      }
      this.$emit('input', this.content)
    },
    handleBlur() {
      this.$emit('blur', this.content)
    },
  },
}
</script>

<style scoped>
.form-input-error {
  border-color: #f00 !important;
}

.form-input {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-sizing: border-box;
}
</style>
